import { render, staticRenderFns } from "./Swipper.vue?vue&type=template&id=02561ca4&scoped=true"
import script from "./Swipper.vue?vue&type=script&lang=js"
export * from "./Swipper.vue?vue&type=script&lang=js"
import style0 from "./Swipper.vue?vue&type=style&index=0&id=02561ca4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02561ca4",
  null
  
)

export default component.exports